import { Column, Box } from 'braid-design-system';
import range from 'lodash/range';
import React from 'react';

import LayoutBox from 'src/components/LayoutBox/LayoutBox';
import { desktopFeatureLabels } from 'src/data/listing-products/desktop';
import { desktopFeatureLabelsFreemium } from 'src/data/listing-products/freemium/desktop';
import { isFreemiumExperiment } from 'src/data/listing-products/products';

const PackageSpacer = () => {
  // +1 accounts for the action button row
  const numberOfRows =
    Object.entries(
      isFreemiumExperiment
        ? desktopFeatureLabelsFreemium
        : desktopFeatureLabels,
    ).length + 1;

  return (
    <Column width="content">
      {range(numberOfRows).map((_, index) => {
        const background =
          index % 2 === 0 && index < numberOfRows - 2
            ? 'neutralLight'
            : 'surface';
        return (
          <Box background={background} padding="xsmall" key={index}>
            <LayoutBox height={80}> </LayoutBox>
          </Box>
        );
      })}
    </Column>
  );
};

export default PackageSpacer;
